import React, { useEffect, useState } from "react";

const Counter = ({ number }) => {
    const [counter, setCounter] = useState(number);

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    console.log(counter)

    return  <span>{counter}</span>
}

export default Counter